var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.624 2.793a1.11 1.11 0 011.502 0l4.782 4.5a.959.959 0 010 1.414l-4.782 4.5a1.11 1.11 0 01-1.502 0 .959.959 0 010-1.414L9.654 8l-4.03-3.793a.959.959 0 010-1.414z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNS42MjM3IDIuNzkyODlDNi4wMzg2MyAyLjQwMjM3IDYuNzExMzcgMi40MDIzNyA3LjEyNjMgMi43OTI4OUwxMS45MDc2IDcuMjkyODlDMTIuMzIyNSA3LjY4MzQyIDEyLjMyMjUgOC4zMTY1OCAxMS45MDc2IDguNzA3MTFMNy4xMjYzIDEzLjIwNzFDNi43MTEzNyAxMy41OTc2IDYuMDM4NjMgMTMuNTk3NiA1LjYyMzcgMTMuMjA3MUM1LjIwODc3IDEyLjgxNjYgNS4yMDg3NyAxMi4xODM0IDUuNjIzNyAxMS43OTI5TDkuNjUzNjUgOEw1LjYyMzcgNC4yMDcxMUM1LjIwODc3IDMuODE2NTggNS4yMDg3NyAzLjE4MzQyIDUuNjIzNyAyLjc5Mjg5WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgRightArrow as ReactComponent };